export const getInfiniteRequestLoadingState = <T>({
  data,
  error,
  size,
  itemsPerPage,
}: {
  data?: { data?: T; paging: { next: string | null } }[];
  error?: Error;
  size: number;
  itemsPerPage: number;
}) => {
  const isLoadingInitialData = !data && !error;
  const isLoadingMore =
    isLoadingInitialData || (size > 0 && data && typeof data[size - 1] === 'undefined');
  const isDone = !data?.[data?.length - 1]?.paging?.next;

  return { isLoadingInitialData, isLoadingMore, isDone };
};
